import { useMutation } from 'react-query';

import { extractResourceChartBarToCsv as mutationFn } from 'api/endPoints/extractResourceChartBarToCsv';

import { Range } from 'components/common/GlobalFiltersInPage/components/RangeFilter/rangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFiltersInPage/components/quickAnswerFilter/quickAnswerFilter';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Aggregation } from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart.consts';

export const useMutationExtractResourceChartBarToCsv = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
    range: Range | undefined;
    startDate: number | null;
    endDate: number | null;
    filter: {
        filters: IFilter[];
    };
    aggregation: Aggregation;
    quickAnswerFilter?: QuickAnswerFilter;
    fileName?: string;
}
